import { ChartColumn } from 'lucide-react';
import { LinkBase, useTranslate } from 'ra-core';
import { DataTable } from '../../components/admin/data-table';
import { ImageField } from '../../components/admin/image-field';
import { buttonVariants } from '../../components/ui/button';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';
import { ResourcesValue } from '../resources';

export const BadgesList = () => (
  <MoonstarList
    actions={<BadgesListActions />}
    sort={{ field: 'name', order: 'ASC' }}
  >
    <DataTable rowClick="edit" bulkActionButtons={false}>
      <DataTable.Col
        source="imageUrl"
        disableSort
        className="w-px whitespace-nowrap"
      >
        <ImageField
          source="imageUrl"
          className="block w-[200px] [&_img]:h-[100px] [&_img]:w-full [&_img]:object-contain"
        />
      </DataTable.Col>
      <DataTable.Col source="name" />
    </DataTable>
  </MoonstarList>
);

const BadgesListActions = () => {
  const translate = useTranslate();

  return (
    <MoonstarListActions
      left={
        <LinkBase
          to={`/${ResourcesValue.BADGES_AWARDS}/analytics`}
          className={buttonVariants({ variant: 'outline' })}
        >
          <ChartColumn />
          {translate('moonstar.analytics.name')}
        </LinkBase>
      }
    />
  );
};
